import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import About from './pages/About';
import Shop from './pages/Shop';
import Videos from './pages/Videos';
import Stream from './pages/Stream';
import Games from './pages/Games';
import Streamers from './pages/Streamers';
import Contact from './pages/Contact';
import "./styles.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/stream" element={<Stream />} />
        <Route path="/games" element={<Games />} />
        <Route path="/streamers" element={<Streamers />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
